import { LitElement, html, css } from '@hh/global.js'

export class HHAccordion extends LitElement {
  static properties = {
    button: { state: true },
    content: { state: true },
    slot: { state: true },
  }

  firstUpdated() {
    super.firstUpdated()
    this.maxHeight = this.getAttribute('max-height')
    this.initAccordion()
  }

  initAccordion() {
    this.slot = this.shadowRoot.querySelector('slot')
    for (const child of this.slot.assignedElements()) {
      if (child.tagName === 'BUTTON') {
        this.button = child
      } else {
        this.content = child
      }
    }

    this.initAccordionAction()
  }

  initAccordionAction() {
    if (this.button) {
      this.button.addEventListener('click', () => {
        this.button.classList.toggle('active')

        const isExpanded = this.button.getAttribute('aria-expanded') === 'true'
        this.button.setAttribute('aria-expanded', (!isExpanded).toString())

        if (isExpanded) {
          this.content.style.display = 'none'
          this.content.style.maxHeight = null
          this.content.setAttribute('aria-hidden', 'true')
          this.content.setAttribute('hidden', '')
        } else {
          this.content.style.display = 'block'
          this.content.style.maxHeight =
            this.maxHeight ?? `${this.content.scrollHeight}px`
          this.content.setAttribute('aria-hidden', 'false')
          this.content.removeAttribute('hidden')
        }
      })
    }
  }

  render() {
    return html`
      <div class="accordion-wrapper">
        <slot></slot>
      </div>
    `
  }
}

customElements.define('hh-accordion', HHAccordion)
